
/**
 * @summary - Component that Provides Footer for Some of the Pages
 * @authos Yuvasri S
 * @since 2024-05-28
 */
import { Grid, Button } from "@mui/material";

const   CustomFooter = ({ cancelClick, 
    saveClick, readOnly, addClick, buttonLabel,showconvertbutton=false,convertClick ,isEdit, showAddButton,saveDisabled=false,disableWoConversionButton=false }) => {
    return (
        <Grid container justifyContent="right" spacing={2} mt={1} mb={2}>
            {!readOnly ? (
                <>
                    <Grid item>
                        <Button onClick={saveClick} variant="contained" disabled={saveDisabled} >
                            {buttonLabel}
                        </Button>
                    </Grid>
                    {showAddButton && !isEdit && (
                        <Grid item>
                            <Button onClick={addClick} variant="contained">
                                Clear
                            </Button>
                        </Grid>
                    )}
                    {showconvertbutton && isEdit && (
                        <Grid item>
                            <Button disabled={disableWoConversionButton} onClick={convertClick} variant="contained">
                                Convert to WO
                            </Button>
                        </Grid>
                    )}
                </>
            ) : null}
            <Grid item>
                <Button onClick={cancelClick} variant="outlined">
                    Back
                </Button>
            </Grid>
        </Grid>
    );
};

export default CustomFooter;
